import { render, staticRenderFns } from "./viewDialog.vue?vue&type=template&id=2c585b0c&scoped=true&"
import script from "./viewDialog.vue?vue&type=script&lang=js&"
export * from "./viewDialog.vue?vue&type=script&lang=js&"
import style0 from "./viewDialog.vue?vue&type=style&index=0&id=2c585b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c585b0c",
  null
  
)

export default component.exports